module.exports = " <table class=\"table table-responsive table-hover admin-table\"> <thead> <tr> <th></th> <th>N°</th> <th>Título</th> <th></th> </tr> </thead> <tbody> <tr class=clickable-row v-for=\"item in list\" id=\"{{ $index }}\" v-drag-and-drop drop=handleDrop> <td> <i class=\"fa fa-bars\"></i> </td> <td>{{ item.id }}</td> <td>{{ item.title }}</td> <td> <i class=\"fa fa-trash\" aria-hidden=true @click=remove(item)></i> </td> </tr> </tbody> </table> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Admin-projects-table.vue
// module id = 539
// module chunks = 0